// Returns true for errors that originate entirely from third-party scripts and
// should not be reported to Rollbar (e.g. Google Maps internal WebGL errors).
function checkIgnore(_isUncaught: boolean, _args: any[], payload: any): boolean {
  try {
    const traceChain: any[] = payload?.body?.trace_chain ?? [];
    const trace: any = payload?.body?.trace ?? null;
    const allTraces = trace ? [trace, ...traceChain] : traceChain;

    for (const t of allTraces) {
      const message: string = t?.exception?.description ?? t?.exception?.message ?? '';
      if (message.includes('EpochMismatch')) {
        // Verify every frame is from Google Maps before suppressing
        const frames: any[] = t?.frames ?? [];
        const allFromMaps = frames.length > 0 && frames.every((f: any) => (f?.filename ?? '').includes('maps.googleapis.com'));
        if (allFromMaps) return true;
      }
    }
  } catch {
    // If inspection itself throws, don't suppress
  }
  return false;
}

interface EnvironmentConfig {
  accessToken: string;
  environment: string;
  captureUncaught: boolean;
  captureUnhandledRejections: boolean;
  enabled?: boolean;
  checkIgnore?: (_isUncaught: boolean, _args: any[], payload: any) => boolean;
}

interface EnvironmentConfigs {
  [key: string]: EnvironmentConfig;
}
const accessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;
if (!accessToken) {
  throw new Error('ROLLBAR_ACCESS_TOKEN environment variable is not defined');
}
const environments: EnvironmentConfigs = {
  development: {
    accessToken: accessToken,
    environment: 'development',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: false,
    checkIgnore,
  },
  test: {
    accessToken: accessToken,
    environment: 'test',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    checkIgnore,
  },
  staging: {
    accessToken: accessToken,
    environment: 'staging',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    checkIgnore,
  },
  production: {
    accessToken: accessToken,
    environment: 'production',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    checkIgnore,
  },
};

export function getRollbarConfig(): EnvironmentConfig {
  const env = process.env.REACT_APP_ENV || 'development';
  const isValidEnv = Object.keys(environments).includes(env);
  if (isValidEnv) {
    return environments[env];
  } else {
    console.log(`Invalid environment for Rollbar: ${env}. Using production environment instead.`);
    return environments['production'];
  }
}
